import { render, staticRenderFns } from "./FormSearch.vue?vue&type=template&id=0ab75d9b"
import script from "./FormSearch.vue?vue&type=script&lang=js"
export * from "./FormSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports